export const API_OPERATIONS = {
  GET: 'API_GET',
  POST: 'API_POST',
  PUT: 'API_PUT',
  DELETE: 'API_DELETE',
  PATCH: 'API_PATCH',
};
